module.exports = __webpack_public_path__ + "img/hi-lo.3d33723.png";